// How large is a table row in Top X by Y widgets
export const ROW_HEIGHT_PX = 32;
// The size of other elements (view all button, padding, margin etc.) inside the content
const CONTENT_PADDING = 14;

/**
 * Given an array of items to be displayed in a Top X by Y widget, compute how many
 * of them should be rendered based on the height of the widget.
 */
export function fitItemsToWidget<T>(items: T[], widgetHeight: number | undefined | null): T[] {
  if (!widgetHeight) {
    return [];
  }
  const maxRows = computeMaxRowsFit(widgetHeight);
  return items.slice(0, Math.min(items.length, maxRows));
}

export function computeMaxRowsFit(widgetHeight: number | undefined | null): number {
  if (!widgetHeight) {
    return 0;
  }
  return Math.floor((widgetHeight - CONTENT_PADDING) / ROW_HEIGHT_PX) - 3
}
